import styled from 'styled-components';

import AddFieldButton from '../AddFieldButton';

export const AddButton = styled(AddFieldButton)<{ hasFields: boolean }>`
  margin-top: ${(props) => (props.hasFields ? '0' : '16px')};
`;

export const AddButtonWrapper = styled.div`
  margin-bottom: 16px;
`;
